<script setup lang="ts">
    import {ref, onMounted,} from 'vue';
    import SliderQuestion from "./SliderQuestion.vue";
    import SingleChoiceQuestion from "./SingleChoiceQuestion.vue";
    import Preapply from "./Preapply.vue";
    import BaseModal from "../../components/modal/BaseModal.vue";

    const props = defineProps(['name', 'questions']);
    const currentQuestionIndex = ref(0);
    const isModalOpen = ref(false);

    function nextQuestion() {
        currentQuestionIndex.value++;
    }

    function getComponentForType(type) {
        switch (type) {
            case 'slider':
                return SliderQuestion;
            case 'single-choice':
                return SingleChoiceQuestion;
            case 'preapply':
                return Preapply;
            default:
                return null;
        }
    }
</script>

<template>
    <div class="w-full flex justify-center items-center">
        <button class="btn btn-secondary text-lg p-4" @click="isModalOpen = true">
            ŞİMDİ ÜCRETSİZ BAŞLA
        </button>
    </div>
    <BaseModal :show="isModalOpen" @close="isModalOpen = false" :border="true">
        <div class="w-full m-8 p-2 lg:p-4">
            <img src="/img/landing/logo.svg" class="mx-auto mb-4" alt="Derslig" />
            <div class="flex">
                <div v-for="(question, index) in questions" :key="index">
                    <component
                        v-show="index === currentQuestionIndex"
                        :is="getComponentForType(question.type)"
                        :name="props.name"
                        :question="question"
                        :no="index"
                        @nextQuestion="nextQuestion"
                    ></component>
                </div>
            </div>
        </div>
    </BaseModal>
</template>
